module.exports = __webpack_public_path__ + "72bf2228.png";